import type { HeaterType, ProfessionalGuidanceResult } from '../../engines/types';
import type { Market } from '../location/types';
import { getT } from '../../i18n';

interface ProfessionalGuidanceInput {
  heaterType: HeaterType;
  includesShower: boolean;
}

export function calculateProfessionalGuidance({
  heaterType,
  includesShower,
}: ProfessionalGuidanceInput, market: Market = 'se'): ProfessionalGuidanceResult {
  const t = getT(market);
  const steps = [
    {
      stepId: 'foundation',
      label: t.domain_prof_foundationLabel,
      requiresProfessional: false,
      reason: t.domain_prof_foundationReason,
    },
    {
      stepId: 'framing',
      label: t.domain_prof_framingLabel,
      requiresProfessional: false,
      reason: t.domain_prof_framingReason,
    },
    {
      stepId: 'systems',
      label: t.domain_prof_systemsLabel,
      requiresProfessional: heaterType === 'electric',
      professionalType: heaterType === 'electric' ? t.domain_prof_systemsElectricType : undefined,
      reason: heaterType === 'electric'
        ? t.domain_prof_systemsElectricReason
        : t.domain_prof_systemsWoodReason,
      estimatedCostSek: heaterType === 'electric' ? 6500 : undefined,
    },
  ];

  if (heaterType === 'wood') {
    steps.push({
      stepId: 'chimney',
      label: t.domain_prof_chimneyLabel,
      requiresProfessional: true,
      professionalType: t.domain_prof_chimneyType,
      reason: t.domain_prof_chimneyReason,
      estimatedCostSek: 9000,
    });
  }

  if (includesShower) {
    steps.push({
      stepId: 'drainage',
      label: t.domain_prof_drainageLabel,
      requiresProfessional: true,
      professionalType: t.domain_prof_drainageType,
      reason: t.domain_prof_drainageReason,
      estimatedCostSek: 7000,
    });
  }

  const professionalSteps = steps.filter((step) => step.requiresProfessional);

  return {
    steps,
    professionalStepCount: professionalSteps.length,
    estimatedTotalCostSek: professionalSteps.reduce((sum, step) => sum + (step.estimatedCostSek ?? 0), 0),
  };
}
